import React from "react";
import PropTypes from "prop-types";

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const ATCSelect = ({ onValid, onCancel  }) => {

    const [value, setValue] = React.useState('');


    return (
        <React.Fragment>
            <TextField autoFocus variant='filled' value={value} onChange={e => setValue(e.target.value.toUpperCase())} />
            <Button onClick={onCancel}>ANNULER</Button>
            <Button disabled={!value} onClick={e => onValid(value)}>VALIDER</Button>
        </React.Fragment>
    );
};

ATCSelect.propTypes = {
    onValid: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default ATCSelect;